import { createReducer } from 'services/reduxHelpers'
import { routeTypes } from 'reduxModules/actions/RouteActions'

/* ------------- Initial State ------------- */

export const initialState = {
  routes: [],
  route: {},
  info: {},
  waitingPassengers: [],
  isLoading: false,
  isWaitingPassengersLoading: false,
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [routeTypes.GET_ROUTES_ATTEMPT]: () => ({
    isLoading: true
  }),
  [routeTypes.GET_ROUTES_SUCCESS]: (_, { data }) => ({
    routes: data,
    isLoading: false
  }),
  [routeTypes.GET_ROUTES_FAILURE]: () => ({
    isLoading: false
  }),

  [routeTypes.SELECT_ROUTE_ATTEMPT]: ({ route: { id } }, { data }) => ({
    route: id === data.id ? {} : data
  }),

  [routeTypes.SUBSCRIBE_INFO_ATTEMPT]: () => ({
    info: {}
  }),
  [routeTypes.SUBSCRIBE_INFO_SUCCESS]: (_, { data }) => ({
    info: data
  }),
  [routeTypes.SUBSCRIBE_INFO_FAILURE]: () => ({
    info: {}
  }),

  [routeTypes.ADD_WAITING_PASSENGER_TO_SHEET_ATTEMPT]: () => ({
    isWaitingPassengersLoading: true
  }),
  [routeTypes.ADD_WAITING_PASSENGER_TO_SHEET_SUCCESS]: (_, { data }) => ({
    isWaitingPassengersLoading: false
  }),
  [routeTypes.ADD_WAITING_PASSENGER_TO_SHEET_FAILURE]: () => ({
    isWaitingPassengersLoading: false
  }),

  [routeTypes.UNSUBSCRIBE_WAITING_PASSENGERS_ATTEMPT]: () => ({
    waitingPassengers: []
  }),

  [routeTypes.SUBSCRIBE_WAITING_PASSENGERS_SUCCESS]: (_, { data: waitingPassengers }) => ({
    waitingPassengers,
  }),
  [routeTypes.SUBSCRIBE_WAITING_PASSENGERS_FAILURE]: () => ({
    waitingPassengers: []
  }),

  [routeTypes.UNSUBSCRIBE_INFO_ATTEMPT]: () => ({
    info: {}
  }),

  [routeTypes.CHANGE_SOURCE_DATA_ATTEMPT]: ({ info }, { data }) => ({
    info: {
      ...info,
      sourcesData: data
    }
  }),

  [routeTypes.CHANGE_ROUTE_INFO_ATTEMPT]: ({ info }, { data: { key, value } }) => ({
    info: {
      ...info,
      [key]: value
    }
  }),

  [routeTypes.DISABLE_ROUTE_ATTEMPT]: ({ info }, { data }) => ({
    info: {
      ...info,
      disabled: data
    }
  }),

  [routeTypes.DISABLE_ROUTE_FAILURE]: ({ info }, { data }) => ({
    info: {
      ...info,
      disabled: !data
    }
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/RouteReducer.js